import type { Customer, GameState } from "../types";
import { CONSTANTS } from "../data";

// Customer preference and archetype algorithms
export const updateCustomerPreferences = (archetype: any, tags: string[]) => {
  // Placeholder: update archetype preferences based on tags
  return archetype;
};

export const getWeightedOrderPool = (
  orderPool: string[],
  archetype: any,
  context: any
): string[] => {
  // Placeholder: return weighted order pool
  return orderPool;
};

// Generate a random customer order based on discovered recipes
export const generateCustomerOrder = (state: GameState, preferenceTag?: string): string => {
  const { discoveredRecipes, activeSeason, trendingDrink } = state;

  const allDiscoveredDrinks = Object.keys(CONSTANTS.RECIPES)
    .filter(recipeId => discoveredRecipes.includes(recipeId))
    .map(recipeId => CONSTANTS.RECIPES[recipeId].result.id);

  if (allDiscoveredDrinks.length === 0) {
    return "espresso"; // Fallback
  }

  // Handle trending drink
  if (trendingDrink.id && Date.now() < trendingDrink.endTime && allDiscoveredDrinks.includes(trendingDrink.id)) {
    // Give trending drink a very high chance
    if (Math.random() < 0.5) { // 50% chance to order the trending drink
      return trendingDrink.id;
    }
  }

  let potentialOrders = [...allDiscoveredDrinks];

  // Handle preference tag
  if (preferenceTag) {
    const preferredDrinks = allDiscoveredDrinks.filter(drinkId => 
      CONSTANTS.ITEM_TAGS[drinkId]?.includes(preferenceTag)
    );
    if (preferredDrinks.length > 0) {
      potentialOrders = preferredDrinks;
    }
  }

  // Handle seasonal drinks
  if (activeSeason) {
    const seasonalDrinks = potentialOrders.filter(drinkId => 
      CONSTANTS.ITEM_TAGS[drinkId]?.includes('seasonal')
    );
    const nonSeasonalDrinks = potentialOrders.filter(drinkId => 
      !CONSTANTS.ITEM_TAGS[drinkId]?.includes('seasonal')
    );

    const wantsSeasonal = Math.random() < CONSTANTS.SEASONAL_ORDER_CHANCE;

    if (wantsSeasonal && seasonalDrinks.length > 0) {
      return seasonalDrinks[Math.floor(Math.random() * seasonalDrinks.length)];
    }
    
    if (nonSeasonalDrinks.length > 0) {
      return nonSeasonalDrinks[Math.floor(Math.random() * nonSeasonalDrinks.length)];
    }
  }

  // Fallback to any potential order
  if (potentialOrders.length > 0) {
    return potentialOrders[Math.floor(Math.random() * potentialOrders.length)];
  }

  // Ultimate fallback
  return allDiscoveredDrinks[Math.floor(Math.random() * allDiscoveredDrinks.length)];
};
